export default "/images/3.svg?a641c44ca7611255814b3553cf3e2bad";